import gql from "graphql-tag";
import qs from "query-string";
import moment from "moment/moment";
import {CargoV2} from "~/apps/packages/auto-visits/queries";

export type OrderItemCargo = {
    id: string,
    code: string
    name: string
    description: string
    type: string
    status: "Новый" | "Завершен" | "Подтвержден автоматически" | "Отменен клиентом" | "Отклонен портом"
    statusDescription?: string
    label: string
    container: {
        number: string
        type: string
        empty: boolean
    }
    tags: {
        agentRelease?: boolean
    }
    arrival: {
        document: {
            date: string,
            number: string
            type: string
        }
    }
}

export type Cargo = {
    id: string,
    code: string
    name: string
    description: string
    type: string
    container: {
        number: string
        type: string
        empty: boolean
    }
    tags: {
        agentRelease?: boolean
    }
    arrival: {
        document: {
            date: string,
            number: string
            type: string
        }
    }
}

export type OrderItem = {
    id: string,
    number: string,
    date: string,
    pin: string,
    status: 'Отменен' | 'Запланирован' | 'Завершен' | 'В работе',
    shipmentByConsignee: boolean,
    carrier?: string | {
        id: string,
        name: string,
    },
    consignee?: string | {
        name: string
        document: string
    }
    cargoInfo?: string
    contract?: {
        id: string
        number: string
        group: string
    }
    cargos?: OrderItemCargo[]
}

export const GetAutoShipmentOrdersDocument = gql`
    query GetAutoShipmentOrders($page: String, $dateFrom: Date, $dateTo: Date, $query: String, $status: [String],) {
        autoShipmentOrders(page: $page, query: $query, dateFrom: $dateFrom, dateTo: $dateTo, status: $status,) @rest(pathBuilder: $pathBuilder) {
            autoShipmentOrders @type(name: "AutoShipmentOrder") {
                id
                number
                status
                date
                pin
                shipmentByConsignee
                carrier
                cargoInfo
            }
            pageInfo {
                countItems
                nextPage
                pageSize
            }
        }
    }
`

export function getAutoShipmentOrdersPathBuilder({args}) {
    const url = 'remote/erp/api/v2/auto-shipment-orders';
    const params = {
        offset: '20'
    }
    if (args.query) {
        params["query"] = args.query;
    }
    if (args.dateFrom) {
        params["date-from"] = moment(args.dateFrom).format("YYYY-MM-DD");
    }
    if (args.dateTo) {
        params["date-to"] = moment(args.dateTo).format("YYYY-MM-DD");
    }
    if (args.status) {
        params["status"] = args.status.join(",");
    }
    if (args.page) {
        params["page"] = args.page;
    }
    return url + "?" + qs.stringify(params);
}

export type GetAutoShipmentOrdersQueryVariables = {
    query?: string
    dateFrom?: number
    dateTo?: number
    status?: OrderItem["status"][]
    pathBuilder: typeof getAutoShipmentOrdersPathBuilder
}

export type GetAutoShipmentOrdersQueryResult = {
    autoShipmentOrders: {
        autoShipmentOrders: OrderItem[],
        pageInfo: {
            countItems: number
            nextPage?: string
            pageSize: number
        }
    }
}


export const GetAutoShipmentOrderDetailDocument = gql`
    query getAutoShipmentOrderDetail($id: String!) {
        autoShipmentOrder(id: $id) @rest(path: "remote/erp/api/v2/auto-shipment-orders/{args.id}") {
            autoShipmentOrder {
                id
                number
                status
                date
                pin
                shipmentByConsignee
                carrier {
                    id
                    name
                }
                contract {
                    id
                    number
                    group
                }
                consignee {
                    name
                    document
                }
                cargos {
                    id
                    code
                    name
                    description
                    type
                    status
                    statusDescription
                    container {
                        number
                        type
                        empty
                    }
                    tags {
                        agentRelease
                    }
                    arrival {
                        document {
                            date
                            number
                            type
                        }
                    }
                }
            }
        }
    }
`

export type GetAutoShipmentOrderQueryVariables = {
    id: string
}

export type GetAutoShipmentOrderQueryResult = {
    autoShipmentOrder: {
        autoShipmentOrder: OrderItem
    }
}

export const GetCargoListDocument = gql`
    query GetCargos($date: String, $page: Int, $query: String, $direction: [String!], $excludeIds: [String!], $type: [String!], $empty: Boolean) {
        cargos(date: $date, page: $page, query: $query, exclude_ids: $excludeIds, type: $type, empty: $empty) @rest(pathBuilder: $pathBuilder) {
            cargos @type(name: "AutoShipmentOrderCargo") {
                id
                code
                name
                description
                type
                container {
                    number
                    type
                    empty
                }
                tags {
                    agentRelease
                }
                arrival {
                    document {
                        date
                        number
                        type
                    }
                }
            }
            pageInfo {
                countItems
                nextPage
                pageSize
            }
        }
    }
`;

export function GetCargoListPathBuilder({args}) {
    const url = [
        "remote/erp/api/v2/cargos",
    ].join("/");
    const params = {
        offset: "20"
    };
    if (args.exclude_ids?.length) {
        params["exclude-cargo"] = args.exclude_ids.join(",");
    }
    if (args.page) {
        params["page"] = args.page;
    }
    if (args.query) {
        params["query"] = args.query;
    }
    if (args.type?.length) {
        params["type"] = args.type.join(",");
    }

    return url + "?" + qs.stringify(params);
}

export type GetCargoListVars = {
    type?: Cargo["type"][]
    date?: number
    page?: number
    query?: string
    empty?: boolean
    excludeIds: string[]
    pathBuilder: typeof GetCargoListPathBuilder,
}
export type GetCargoListResult = {
    cargos: {
        cargos: Cargo[]
        pageInfo: {
            countItems: number
            nextPage?: string
            pageSize: number
        }
    }
}

export type Contract = {
    id: string
    number: string
    group: string
}

export const GetContractListDocument = gql`
    query GetContracts {
        autoShipmentOrderContracts @rest(path: "remote/erp/api/v2/contracts?active") {
            contracts {
                id
                number
                group
            }
        }
    }
`;
export type GetContractListQueryVars = {}
export type GetContractListQueryResult = {
    autoShipmentOrderContracts: {
        contracts: Contract[]
    }
}

export type Carrier = {
    id: string,
    name: string
}

export const GetCarriersListDocument = gql`
    query GetCarriers {
        autoShipmentOrderCarriers @rest(path: "remote/erp/api/v2/carriers") {
            carriers {
                id
                name
            }
            additionalCarriers{
                id
                name
            }
        }
    }
`;

export type GetCarriersListQueryVars = {}
export type GetCarriersListQueryResult = {
    autoShipmentOrderCarriers: {
        carriers: Carrier[],
        additionalCarriers: Carrier[]
    }
}